var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.92188 8.76562C2.92188 18.6029 10.8971 26.5781 20.7344 26.5781H23.4062C24.1149 26.5781 24.7945 26.2966 25.2956 25.7956C25.7966 25.2945 26.0781 24.6149 26.0781 23.9062V22.277C26.0781 21.6643 25.6613 21.1299 25.0664 20.9814L19.8141 19.6681C19.2916 19.5374 18.7429 19.7334 18.4211 20.1632L17.2692 21.6987C16.9344 22.1452 16.3561 22.3423 15.8324 22.1499C13.8883 21.4352 12.1228 20.3064 10.6582 18.8418C9.19355 17.3772 8.06479 15.6117 7.35006 13.6676C7.15769 13.1439 7.35481 12.5656 7.80131 12.2308L9.33675 11.0789C9.76781 10.7571 9.96256 10.2073 9.83194 9.68594L8.51856 4.43362C8.44629 4.1447 8.27954 3.88821 8.04481 3.7049C7.81008 3.52159 7.52083 3.42197 7.223 3.42188H5.59375C4.88512 3.42188 4.20552 3.70338 3.70445 4.20445C3.20338 4.70552 2.92188 5.38512 2.92188 6.09375V8.76562Z",
    stroke: "#00C0D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.205a2ed6997f536eac5c3c8d8b365ca3.svg";
export { ForwardRef as ReactComponent };